

export default function createObserver (observerType, observerNode, callback, observerConfig = {}) {
  if (observerType in window) {
    const Observer = window[observerType];
    let observer;

    // IntersectionObserver has different "API" from other Observers
    if (observerType === 'IntersectionObserver') {
      observer = new Observer(callback, observerConfig);
      observer.observe(observerNode);
    } else {
      observer = new Observer(callback);
      observer.observe(observerNode, observerConfig);
    }

    return {
      observer,
      observerDestructor: () => observer.disconnect()
    };
  }

  // fallback code for browsers that doesn't support current observer type
  return {
    observer: null,
    observerDestructor () {}
  };
}
